import { toast } from "react-toastify";
import fetchRedux from "../../../../api/fetch_redux";
import { ToastErro } from "../../../../utils/utilitarios";

export const USERS_PAGE_VARIABLE_INIT = "USERS_PAGE_VARIABLE_INIT";
export const USERS_PAGE_VARIABLE_ADD = "USERS_PAGE_VARIABLE_ADD";
export const USERS_PAGE_VARIABLE_EDIT = "USERS_PAGE_VARIABLE_EDIT";
export const USERS_PAGE_VARIABLE_DELETE = "USERS_PAGE_VARIABLE_DELETE";

const ROUTE = ["/variavel_api"];

export const usersPageVariableInit = () => (dispatch) => {
  fetchRedux(
    ROUTE[0],
    "GET",
    null,
    (result) => {
      dispatch({
        type: USERS_PAGE_VARIABLE_INIT,
        data: result,
      });
    },
    null,
    (err) => ToastErro(err)
  );
};

export const usersPageVariableAddEdit = (data, setWait) => (dispatch) => {
  fetchRedux(
    ROUTE[0],
    data?.id ? "PUT" : "POST",
    data,
    (result) => {
      toast.dark(result.sucesso, { type: "success" });
      dispatch({
        type: data?.id ? USERS_PAGE_VARIABLE_EDIT : USERS_PAGE_VARIABLE_ADD,
        data: result.data,
      });
    },
    setWait,
    (err) => ToastErro(err)
  );
};

export const usersPageVariableDelete = (id, setWait) => (dispatch) => {
  fetchRedux(
    ROUTE[0],
    "DELETE",
    { id: id },
    (result) => {
      toast.dark(result.sucesso, { type: "success" });
      dispatch({
        type: USERS_PAGE_VARIABLE_DELETE,
        data: id,
      });
    },
    setWait,
    (err) => ToastErro(err)
  );
};
